var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",attrs:{"size":_vm.size,"color":_vm.color,"stroke-width":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }